<template>
<div>
  <b-table :items="items" hover bordered :fields="fields">
    <template v-slot:cell(status)="data">
      <c-switch class="mx-1" color="primary" variant="3d" size="sm" v-model="data.item.selected" />
    </template>
  </b-table>
  <b-button type="submit" variant="primary" @click="onSubmit">Submit</b-button>
  <b-button class="ml-1" type="reset" @click="onCancel">Cancel</b-button>
</div>
</template>

<script>
import Vue from 'vue'
import {
  mapState,
  mapActions
} from 'vuex'
import {
  Switch as cSwitch
} from '@coreui/vue'
export default {
  name: 'UserPermisions',
  props: {
    user: Object
  },
  components: {
    cSwitch
  },
  computed: mapState({
    roles: state => state.roles.all,
  }),
  data: () => {
    return {
      items: [],
      fields: [{
          key: 'name',
          label: 'Role Name',
          sortable: true
        },
        {
          key: 'status',
          label: 'On/Off',
          sortable: true
        }
      ],
    }
  },
  methods: {
    onSubmit() {
      let roleIds = []
      _.forEach(this.items, (item) => {
        if (item.selected) {
          roleIds.push(item.id)
        }
      })

      let params = {
        id: this.user.id,
        role_ids: roleIds
      }

      this.$store.dispatch('users/setRoles', params)
        .then((response) => {
          this.$emit('success')
          this.showSuccessMsg()
        }).catch(() => {
          this.showErrorMsg
        })
    },
    onCancel() {
      this.$emit('cancel')
    }
  },
  beforeMount() {
    this.items = _.map(this.roles, (role) => {
      return {
        id: role.id,
        name: role.name,
        selected: false
      }
    })
    _.forEach(this.user.roles, (userRole) => {
      var index = _.findIndex(this.items, {
        id: userRole.id
      });
      this.items[index].selected = true
    })
  }
}
</script>
